import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { RewardsService } from '../../../services/rewards.service';
import { Table } from 'primeng/table';
import { Dropdown } from "primeng/dropdown";
import { RoleService } from '../../../services/role.service';
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import * as moment from "moment";
import { saveAs } from 'file-saver/src/FileSaver';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  styles: [`
    :host ::ng-deep .p-datatable-gridlines p-progressBar {
        width: 100%;
    }
    @media screen and (max-width: 960px) {
        :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
            display: flex;
        }
    }
  `],
  providers: [MessageService, ConfirmationService, TitleCasePipe, RewardsService]
})

export class RewardListComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  rewardlist: any;
  totalRecords: 0;
  errorMessage = '';
  loading: boolean;
  calvalue: Date;
  ucalvalue: Date;
  statuses: any[];
  sizes: any[];
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  public loggedInUser;
  public userId;
  public userRoleId;
  public rewardModule;
  public loggedInUserPermissions;
  public rewardPermissions: any[] = [];
  lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
  downloadFlg: boolean;
  downloadrewardlist: any;
  reward_name: any;
  description: any;
  coins_required: any;
  createdby: any;
  updatedby: any;
  startDate: Date;
  endDate: Date;

  constructor(private rewardsService: RewardsService, private router: Router, private roleService: RoleService, private messageService: MessageService, private confirmationService: ConfirmationService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.downloadFlg = false;   
    this.loggedInUser = this.tokenStorageService.getUser();
    this.userId = this.loggedInUser.userdata.id;
    this.userRoleId = this.loggedInUser.userdata.role;
    this.rewardModule = "Rewards Management";
    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();
    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.rewardModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.rewardPermissions.push(permissionObj);
      }
    });
    if (this.rewardPermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }
    this.rewardPermissions = this.rewardPermissions[0]['permission'];
    this.sizes = [
      { label: 'Yes', value: true },
      { label: 'No', value: false }
    ];
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
  }

  addNewReward() {
    this.router.navigate(['/manage/rewards/add']);
  }

  editReward(id) {
    this.router.navigate(['/manage/rewards/' + id]);
  }

  requestList(id) {
    this.router.navigate(['/manage/rewards/request-list/' + id]);
  }

  loadRewards(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber;
    var params = "";
    if (event.first == 0) {
      pagenumber = event.first + 1;
    } else {
      pagenumber = (event.first / event.rows) + 1;
    }
    if (event.filters != undefined && event.filters["reward_name"] != undefined) {
      params += "&filterByRewardName=" + event.filters["reward_name"].value;
    }
    if (event.filters != undefined && event.filters["description"] != undefined) {
      params += "&filterByDescription=" + event.filters["description"].value;
    }
    if (event.filters != undefined && event.filters["size"] != undefined) {
      params += "&filterBySize=" + event.filters["size"].value;
    }
    if (event.filters != undefined && event.filters["coins_required"] != undefined) {
      params += "&filterByCoins=" + event.filters["coins_required"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value; 
    }
    if (event.filters != undefined && event.filters["created_at"] != undefined) {
      const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["createdby"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdby"].value;
    }
    if (event.filters != undefined && event.filters["updated_at"] != undefined) {
      const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
      params += "&filterByUpdatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["updatedby"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
    }
    if (this.startDate != undefined && this.endDate != undefined) {
    params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
    params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + event.rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + event.rows + "&pageNumber=" + pagenumber;
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    var querystring = "filterByroleName=admin";
    this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.rewardsService.getRewardList(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.loading = false;
        this.rewardlist = data.data;
        this.totalRecords = data.totalCount;
        this.rewardlist.forEach(element => {
          element.created_at = new Date(element.created_at);
          element.updated_at = new Date(element.updated_at);
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.loadRewards(this.lastTableLazyLoadEvent); 
    this.dt.filter('', 'reward_name', 'contains');
    this.dt.filter('', 'description', 'contains');
    this.dt.filter('', 'size', 'contains');
    this.dt.filter('', 'coins_required', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.dt.filter('', 'createdby', 'contains');
    this.dt.filter('', 'updated_at', 'dateIs');
    this.dt.filter('', 'updatedby', 'contains');
    this.calvalue = null;
    this.ucalvalue = null;
    this.reward_name = '';
    this.description = '';
    this.coins_required = '';
    this.createdby = '';
    this.updatedby = '';
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
    this.pDropDownId2.clear(null);
    if (this.pDropDownId2) {
      this.pDropDownId2.value = null;
    }
  }

  deleteReward(reward) {
    this.confirmationService.confirm({   
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">
          You want to delete this record ?
        </p>
      `,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      acceptIcon: '',
      rejectIcon: '' , 
      accept: () => {
        var disableStatus;
        if (reward.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var rewardData = '{"disable":' + disableStatus + '}';
        this.rewardsService.updateReward(reward.id, rewardData).pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.messageService.add({ key: 'toastMsg', severity: 'success', summary: 'Successful', detail: 'Reward Deleted Successfully', life: 3000 });
          setTimeout(() => {
            this.loadRewards(this.lastTableLazyLoadEvent);
          }, 2000);
        },
        ((err) => {
          this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 3000 });
        }));
      },
      reject: () => {
      }
    });
  }

  exportExcel() {
      this.downloadFlg = true;
      this.loadRewards(this.lastTableLazyLoadEvent);
      var propertiesRemove = ['id', 'created_at', 'createdby', 'updatedby', 'disable', 'updated_at', 'categoryId', 'brandcategoryId', 'status', 'created_by', 'Modification_Date'];
      this.downloadrewardlist = this.rewardlist;
      
      import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.downloadrewardlist);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "RewardList");
      });
  }
  
  
  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
          });
          let filename;
          filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
          saveAs(data, filename);
      });
  }

  changeStatus(reward) {
    this.confirmationService.confirm({
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">
          You want to change this status ?
        </p>
      `, 
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      acceptIcon: '',
      rejectIcon: '' , 
      accept: () => {
        var rewardData = '{"status":' + reward.status + '}';
        this.rewardsService.updateReward(reward.id, rewardData).pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Reward Status Updated', life: 3000 });
          this.loadRewards(this.lastTableLazyLoadEvent);
        },
        err => {
          this.errorMessage = err.error.message;
        });
      },
      reject: () => {
        this.loadRewards(this.lastTableLazyLoadEvent);
      }
    });
  }

  changeSize(reward) {
    this.confirmationService.confirm({
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">
          You want to change this status ?
        </p>
      `, 
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      acceptIcon: '',
      rejectIcon: '' , 
      accept: () => {
        var rewardData = '{"size":' + reward.size + '}';
        this.rewardsService.updateReward(reward.id, rewardData).pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Reward Size Available Updated', life: 3000 });
          this.loadRewards(this.lastTableLazyLoadEvent);
        },
        err => {
          this.errorMessage = err.error.message;
        });
      },
      reject: () => {
        this.loadRewards(this.lastTableLazyLoadEvent);
      }
    });
  }

  addColumns() {
    this.hide = false;
  }

  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}